import { RecaptchaVerifier } from 'firebase/auth';
import type { ApplicationVerifier } from 'firebase/auth';

import { auth } from '@/shared';

let verifier: RecaptchaVerifier | null = null;
let shell: HTMLDivElement | null = null;
let badgeStyleInjected = false;

function hideBadge(): void {
  if (badgeStyleInjected) return;
  const style = document.createElement('style');
  style.textContent = '.grecaptcha-badge { visibility: hidden !important; }';
  document.head.appendChild(style);
  badgeStyleInjected = true;
}

function getShell(): HTMLDivElement {
  if (shell && shell.isConnected) return shell;

  shell = document.createElement('div');
  shell.setAttribute('aria-hidden', 'true');
  shell.style.position = 'absolute';
  shell.style.width = '0';
  shell.style.height = '0';
  shell.style.overflow = 'hidden';
  document.body.appendChild(shell);
  hideBadge();
  return shell;
}

export function getRecaptchaVerifier(): ApplicationVerifier {
  if (verifier) return verifier;

  const parent = getShell();
  const slot = document.createElement('div');
  parent.appendChild(slot);

  verifier = new RecaptchaVerifier(auth, slot, { size: 'invisible' });
  return verifier;
}

export function resetRecaptchaVerifier(): void {
  if (!verifier) return;
  verifier.clear();
  verifier = null;
}
